/* eslint-disable no-unused-vars */
export enum EHttpMethods {
  DELETE = "DELETE",
  POST = "POST",
  GET = "GET",
  PUT = "PUT",
  PATCH = "PATCH",
}

export enum EContractActionsType {
  PROVIDER_INITIATE_CONTRACT = "PROVIDER_INITIATE_CONTRACT",
  CUSTOMER_INITIATE_CONTRACT = "CUSTOMER_INITIATE_CONTRACT",
  BROKER_CREATE_CONTRACT = "BROKER_CREATE_CONTRACT",
  PROVIDER_CREATE_CONTRACT = "PROVIDER_CREATE_CONTRACT",
  CUSTOMER_CREATE_CONTRACT = "CUSTOMER_CREATE_CONTRACT",
  PROVIDER_DELETE_CONTRACT = "PROVIDER_DELETE_CONTRACT",
  CUSTOMER_DELETE_CONTRACT = "CUSTOMER_DELETE_CONTRACT",
  ADMIN_DELETE_CONTRACT = "ADMIN_DELETE_CONTRACT",
  RECEIVER_ACCEPT_CONTRACT = "RECEIVER_ACCEPT_CONTRACT",
  CUSTOMER_FUND = "CUSTOMER_FUND",
  CUSTOMER_REQUEST_PAYMENT_VERIFICATION = "CUSTOMER_REQUEST_PAYMENT_VERIFICATION",
  CUSTOMER_UPLOAD_PAYMENT_DOCS = "CUSTOMER_UPLOAD_PAYMENT_DOCS",
  CUSTOMER_CONFIRM_DELIVERY = "CUSTOMER_CONFIRM_DELIVERY",
  CUSTOMER_DENY_DELIVERY = "CUSTOMER_DENY_DELIVERY",
  ADMIN_CONFIRM_DELIVERY = "ADMIN_CONFIRM_DELIVERY",
  ADMIN_ACCEPT_ITEM = "ADMIN_ACCEPT_ITEM",
  CUSTOMER_ACCEPT_ITEM = "CUSTOMER_ACCEPT_ITEM",
  CUSTOMER_REJECT_ITEM = "CUSTOMER_REJECT_ITEM",
  CUSTOMER_CHECK_ESCALATION = "CUSTOMER_CHECK_ESCALATION",
  PROVIDER_CHECK_ESCALATION = "PROVIDER_CHECK_ESCALATION",
  PROVIDER_ESCALATE_DELIVERY = "PROVIDER_ESCALATE_DELIVERY",
  PROVIDER_REMIND_CUSTOMER_TO_CONFIRM_DELIVERY = "PROVIDER_REMIND_CUSTOMER_TO_CONFIRM_DELIVERY",
  PROVIDER_REMIND_CUSTOMER_TO_CONFIRM_INSPECTION = "PROVIDER_REMIND_CUSTOMER_TO_CONFIRM_INSPECTION",
  PROVIDER_ESCALATE_ITEM = "PROVIDER_ESCALATE_ITEM",
  ADMIN_RESOLVE_ESCALATION_REFUND_CUSTOMER = "ADMIN_RESOLVE_ESCALATION_REFUND_CUSTOMER",
  ADMIN_RESOLVE_ESCALATION_RELEASE_PROVIDER = "ADMIN_RESOLVE_ESCALATION_RELEASE_PROVIDER",
  ADMIN_CLOSE_REFUND_CUSTOMER = "ADMIN_CLOSE_REFUND_CUSTOMER",
  ADMIN_CLOSE_RELEASE_FUND_TO_PROVIDER = "ADMIN_CLOSE_RELEASE_FUND_TO_PROVIDER",
  ADMIN_COMPLETE_RELEASE_FUND_TO_PROVIDER = "ADMIN_COMPLETE_RELEASE_FUND_TO_PROVIDER",
  ADMIN_VERIFY_PAYMENT = "ADMIN_VERIFY_PAYMENT",
  ADMIN_DENY_PAYMENT = "ADMIN_DENY_PAYMENT",
  SYSTEM_CONFIRM_DELIVERY = "SYSTEM_CONFIRM_DELIVERY",
  CUSTOMER_CHANGE_REQUESTED = "CUSTOMER_CHANGE_REQUESTED",
  SELLER_APPROVE_CONTRACT = "SELLER_APPROVE_CONTRACT",
  SELLER_REJECT_CONTRACT = "SELLER_REJECT_CONTRACT",
  SYSTEM_REJECT_CONTRACT = "SYSTEM_REJECT_CONTRACT",
  DELETE_NOT_PAID_CONTRACT = "DELETE_NOT_PAID_CONTRACT",
  SENDER_DELETE_CONTRACT = "SENDER_DELETE_CONTRACT",
  SENDER_UPDATE_STOCK = "SENDER_UPDATE_STOCK",
  CASH_OUT = "CASH_OUT",
  SYSTEM_UPDATE_STOCK = "SYSTEM_UPDATE_STOCK",
  ACCEPT_CONTRACT = "ACCEPT_CONTRACT",
  BACK_TO_SUBMITTED = "BACK_TO_SUBMITTED",
  BROKER_ACCEPT_ITEM = "BROKER_ACCEPT_ITEM",
  BROKER_REFUND_CUSTOMER = "BROKER_REFUND_CUSTOMER",
  SUBMIT = "SUBMIT",
  MONEY_BACKED_TO_USER_CONFIRMED = "MONEY_BACKED_TO_USER_CONFIRMED",
  SYSTEM_ACCEPT_ITEM = "SYSTEM_ACCEPT_ITEM",
  SYSTEM_TRIGGER_COMPLEX_CONTRACT = "SYSTEM_TRIGGER_COMPLEX_CONTRACT",
  BACK_TO_IN_PROGRESS = "BACK_TO_IN_PROGRESS",
  COMPLETE_COMPLEX_CONTRACT = "COMPLETE_COMPLEX_CONTRACT",
  FULLY_FUNDED = "FULLY_FUNDED",
  FULLY_REFUNDED = "FULLY_REFUNDED",
  FULLY_ACCEPTED = "FULLY_ACCEPTED",
  ARBITRATOR_CONFIRM_DELIVERY = "ARBITRATOR_CONFIRM_DELIVERY",
  ARBITRATOR_RESOLVE_REFUND_CUSTOMER = "ARBITRATOR_RESOLVE_REFUND_CUSTOMER",
  MILESTONE_CONTRACT_ADD_PARTIES = "MILESTONE_CONTRACT_ADD_PARTIES",
  PARTY_JOINED = "PARTY_JOINED",
  CASH_OUT_FAILED = "CASH_OUT_FAILED",
  SYSTEM_SETTLE_ITEM = "SYSTEM_SETTLE_ITEM",
  ADMIN_SETTLE_ITEM = "ADMIN_SETTLE_ITEM",
  CLIENT_DELETE_CONTRACT = "CLIENT_DELETE_CONTRACT",
  CLIENT_ADMIN_ADD_PARTY_TO_CONTRACT = "CLIENT_ADMIN_ADD_PARTY_TO_CONTRACT",
}

export enum ECONTRACT_STATUS {
  PENDING_PAID = "PENDING_PAID",
  PARTIAL_CONFIRMED_DELIVERY = "PARTIAL_CONFIRMED_DELIVERY",
  PARTIAL_ITEM_ACCEPTED = "PARTIAL_ITEM_ACCEPTED",
  BROKER_CREATE_CONTRACT = "BROKER_CREATE_CONTRACT",
  BROKER_CREATED = "BROKER_CREATED",
  SUBMITTED = "SUBMITTED",
  CREATED = "CREATED",
  ADDING_PARTY = "ADDING_PARTY",
  SHIPPED = "SHIPPED",
  READY_FOR_PAYMENT = "READY_FOR_PAYMENT",
  WAITING_FOR_SETTLEMENT_RESOLVE = "WAITING_FOR_SETTLEMENT_RESOLVE",
  WAITING_FOR_SETTLEMENT_CLOSE = "WAITING_FOR_SETTLEMENT_CLOSE",
  IN_PROGRESS = "IN_PROGRESS",
  PARTIALLY_REFUNDED = "PARTIALLY_REFUNDED",
  PARTIALLY_RESOLVE_RELEASED = "PARTIALLY_RESOLVE_RELEASED",
  PARTIALLY_PAID = "PARTIALLY_PAID",
  PARTIALLY_RELEASED = "PARTIALLY_RELEASED",
  WAITING_FOR_DELIVERY = "WAITING_FOR_DELIVERY",
  ITEM_INSPECTION = "ITEM_INSPECTION",
  CONTRACT_ACCEPTED = "CONTRACT_ACCEPTED",
  COMPLETED = "COMPLETED",
  CLOSED_REFUND_CUSTOMER = "CLOSED_REFUND_CUSTOMER",
  CLOSED_RELEASE_PROVIDER = "CLOSED_RELEASE_PROVIDER",
  DELIVERY_ESCALATION = "DELIVERY_ESCALATION",
  INSPECTION_ESCALATION = "INSPECTION_ESCALATION",
  PAID = "PAID",
  WAITING_FOR_SHIPMENT = "WAITING_FOR_SHIPMENT",
  ITEM_ACCEPTED = "ITEM_ACCEPTED",
  WAITING_FOR_APPROVAL = "WAITING_FOR_APPROVAL",
  RESOLVED_REFUND_CUSTOMER = "RESOLVED_REFUND_CUSTOMER",
  RESOLVED_RELEASE_PROVIDER = "RESOLVED_RELEASE_PROVIDER",
  DRAFT = "DRAFT",
  ARCHIVED = "ARCHIVED",
  CONTRACT_REJECTED = "CONTRACT_REJECTED",
  CONTRACT_ESCALATED = "Contract_Escalated", //TODO to be updated or removed when backend confirm
  CANCELED = "CANCELED",
  DELETED = "DELETED",
  DELIVERY_ACCEPTED = "DELIVERY_ACCEPTED",
  PENDING_APPROVAL = "PENDING_APPROVAL",
  OUT_OF_STOCK = "OUT_OF_STOCK",
  PENDING_PAYMENT_VERIFICATION = "PENDING_PAYMENT_VERIFICATION",
  READY_FOR_CASH_OUT = "READY_FOR_CASH_OUT",
  CASH_OUT_APPROVED = "CASH_OUT_APPROVED",
  PARTIAL_CASHOUT = "PARTIAL_CASHOUT",
  EXCEPTIONAL_COMPLETED = "EXCEPTIONAL_COMPLETED",
}

export enum EPARTY_STATUS {
  PAID = "PAID",
  ESCALATED = "ESCALATED",
  PAYMENT_REJECTED = "PAYMENT_REJECTED",
  INVITED = "INVITED",
  JOINED = "JOINED",
  REJECTED_INVITE = "REJECTED_INVITE",
  REFUNDED = "REFUNDED",
  AVAILABLE_BALANCE = "AVAILABLE_BALANCE",
  ARBITRATOR_REFUNDED_CUSTOMER = "ARBITRATOR_REFUNDED_CUSTOMER",
  WAITING_FOR_PAYMENT = "WAITING_FOR_PAYMENT",
  PAYMENT_PENDING_APPROVAL = "PAYMENT_PENDING_APPROVAL",
  WAITING_FOR_ITEM_ACCEPTANCE = "WAITING_FOR_ITEM_ACCEPTANCE",
  ITEM_ACCEPTED = "ITEM_ACCEPTED",
  ITEM_DELIVERED = "ITEM_DELIVERED",
  WAITING_FOR_RELEASE = "WAITING_FOR_RELEASE",
  RELEASED = "RELEASED",
  WAITING_FOR_DELIVERY = "WAITING_FOR_DELIVERY",
  ARBITRATOR_ACCEPT_ITEM = "ARBITRATOR_ACCEPT_ITEM",
  ARBITRATOR_ACCEPT_DELIVERY = "ARBITRATOR_ACCEPT_DELIVERY",
  ARBITRATOR_REJECT_ITEM = "ARBITRATOR_REJECT_ITEM",
  ARBITRATOR_REJECT_DELIVERY = "ARBITRATOR_REJECT_DELIVERY",
}

export enum SENDER_ROLE {
  PROVIDER = "PROVIDER",
  CUSTOMER = "CUSTOMER",
}

export enum USER_ROLE {
  BROKER = "BROKER",
  SELLER = "SELLER",
  BUYER = "BUYER",
}

export enum CURRENCY {
  SAR = "ريال",
}

export const ALERTMESSAGE = {
  SUCCESS: "النجاح",
  ERROR: "خطأ",
};

export const CONTRACTSITEMS = [
  {
    key: "SUCCESS_CONTRACT",
    items: [
      "ITEM_ACCEPTED",
      "COMPLETED",
      "CLOSED_RELEASE_PROVIDER",
      "CLOSED_REFUND_CUSTOMER",
    ],
    icon: "OpenBoxDone",
  },
  {
    key: "ACTIVE_CONTRACT",
    items: ["CREATED", "WAITING_FOR_DELIVERY", "ITEM_INSPECTION"],
    icon: "OpenBox",
  },
  {
    key: "ESCALATION",
    items: ["DELIVERY_ESCALATION", "INSPECTION_ESCALATION"],
    icon: "Return",
  },
  {
    key: "ESCALATION_DONE",
    items: ["RESOLVED_RELEASE_PROVIDER", "RESOLVED_REFUND_CUSTOMER"],
    icon: "PackageBox",
  },
];

export const CONTRACT_STATS = {
  HEADING: "المعاملات",
  SUCCESS_CONTRACT: "المعاملات الناجحة",
  ACTIVE_CONTRACT: "المعاملات النشطة",
  ESCALATION: " جاري التحكيم",
  ESCALATION_DONE: "حل النزاع",
};

export const MAP_STATE_TEXT = {
  ITEM_ACCEPTED: "عملية ناجحة",
  COMPLETED: "تمت المعاملة بنجاح",
  CLOSED_RELEASE_PROVIDER: "انتهت المعاملة لصالح البائع",
  CLOSED_REFUND_CUSTOMER: "انتهت  المعاملة صالح المشترى",

  CREATED: " بإنتظار مشتري",
  WAITING_FOR_DELIVERY: "جارى التوصيل",
  ITEM_INSPECTION: "جارى الفحص",

  DELIVERY_ESCALATION: "مرحلة التوصيل",
  INSPECTION_ESCALATION: "مرحلة الفحص",

  RESOLVED_RELEASE_PROVIDER: "لصالح البائع",
  RESOLVED_REFUND_CUSTOMER: "لصالح المشترى ",
};

export const ORG_MAP_STATE_TEXT = {
  ITEM_ACCEPTED: "عملية ناجحة",
  COMPLETED: "تمت المعاملة بنجاح",
  CLOSED_RELEASE_PROVIDER: "انتهت المعاملة لصالح المستفيدون ",
  CLOSED_REFUND_CUSTOMER: "انتهت  المعاملة لصالح الموكلون بالدفع",
};
